import { CURRENT_DISTRICT } from '../../constants/FieldTypeConstants';

/**
 * Returns a shallow copy of values with currentDistrict normalized to a string
 * for the update profile API (which expects current_district as string).
 * Prefers values.current_district; else extracts district_name or district_id
 * from values.currentDistrict when it is an object.
 */
export const getValuesWithNormalizedDistrictForUpdateProfile = (
  values: Record<string, any>
): Record<string, any> => {
  const copy = { ...values };

  if (typeof values['current_district'] === 'string' && values['current_district'].trim() !== '') {
    copy[CURRENT_DISTRICT] = values['current_district'];
    return copy;
  }

  const district = values['currentDistrict'];
  if (typeof district === 'string' && district.trim() !== '') {
    return copy;
  }
  if (district && typeof district === 'object') {
    const districtObj = district as Record<string, string>;
    const districtName = districtObj['district_name'] || districtObj['district_id'];
    if (districtName) {
      copy[CURRENT_DISTRICT] = districtName;
    }
  }

  return copy;
};
